
import { useState,useEffect } from "react";
import viewmyresultapi from '../api/viewmyresultapi';
import loginapi from '../api/login';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { APISERVERURL } from '../APIServerURL';
import Card from "../studentcomponents/SemResCard";

function ViewMyResult({accessToken,setAccessToken,setRefreshFailed}) {
  const navigate = useNavigate();   
  const { session} = useParams();
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  const [courses,setCourses]=useState([]);

  const [rollNo,setRollNo]=useState('');
  const [name,setName]=useState('');
  const [examSession,setExamSession]=useState('');
  const [examSemesters,setExamSemesters]=useState([]);
  const [isTranscript,setIsTranscript]=useState("NO");
  
 function setStates(data)
 {
   if(data)
   {
     setRollNo(data.studentDetails.rollno||'');
     setName(data.studentDetails.name||'');
     setExamSession(data.examSession||'');
     setExamSemesters(data.examSemesters||[]);
     setIsTranscript(data.isTranscript||"NO");
   }
   else{
    setRollNo('');
    setName('');
    setExamSession('');
    setExamSemesters([]);
    setIsTranscript("NO");
   }
 }

  useEffect(()=>{
    const fetchAT=async ()=>{
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/getExamSemestersWithStatus',{session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setStates(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/getExamSemestersWithStatus',{session},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setStates(response.data); 
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[]);
  
  
  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/studentpdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }

const getGradeCardsOfAStudent=async (e,semester)=>{
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await viewmyresultapi.post('/getMyGradeCard',{semester,examSession},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await viewmyresultapi.post('/getMyGradeCard',{semester,examSession},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}
const getMyTranscript=async (e)=>{
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await viewmyresultapi.post('/getMyTranscript',{examSession},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await viewmyresultapi.post('/getMyTranscript',{examSession},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}


  const handleGoBack = () => {
    navigate(`/`); 
  };
   
    return (
      <main className="w-full">

        <div className="flex flex-col items-center w-full">

        <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">VIEW RESULT</h1>
            <p className="w-full text-center text-xs text-gray-500"> <span>...</span></p>     
          </div>

          <div className="w-full mt-4">
          {isAppLoaded ? (
            <>
            <div className="flex flex-col  w-full justify-center">

                <div className="flex flex-col w-full justify-center items-center">
                    <p className="text-gray-500 text-xs">Name:</p>
                    <p  className="text-gray-900 text-sm">{name}</p>
                </div>
            
            <div className="flex flex-col w-full justify-center items-center mt-4">
            <p className="text-gray-500 text-xs">RollNo:</p>
            <p  className="text-gray-900 text-sm">{rollNo}</p>
                </div>

                <div className="flex flex-col w-full justify-center items-center mt-4">
                <p className="text-gray-500 text-xs">Exam:</p>
                <p  className="text-gray-900 text-sm">{examSession}</p>
                </div>

               <div className="flex flex-wrap w-full justify-center items-center mt-4 gap-2">
                {examSemesters && examSemesters.length > 0 ? (
                  <>
                    {examSemesters.map((semester, index) => (
                      <Card
                        key={index}
                        data={semester}
                        getGradeCardsOfAStudent={getGradeCardsOfAStudent}
                      />
                    ))}
                    {!rollNo.startsWith("PHD")&&
                      (<div
                        className={`w-[160px] h-[150px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300
                          bg-gradient-to-r from-blue-600 to-blue-300 hover:from-blue-600 hover:to-blue-500 text-white`
                        }
                      >
                        <button 
                                 onClick={(e) => getMyTranscript(e)} 
                                  className="flex text-xs items-center gap-2 bg-orange-600 text-white px-2 py-2 rounded-lg hover:bg-orange-700 transition duration-200"
                                >
                                
                                  CONSOLIDATED GRADECARD
                                </button>
                        </div>)
                    }
                  </>
                ) : (
                  <div className="text-gray-500">Nothing to display</div>
                )}
              </div>

            
            </div>
            </>
          ) : (
            <p>Please wait...</p>
          )}
          </div>
        </div>

     
      </main>
    )
  }
  
  export default ViewMyResult